import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Divider } from '@mui/material';
import { $contactCalls, clearEndedCalls } from '../../model/calls';
import { $isLoading, $isPopperVisible } from '../../model/main';
import * as Styled from './styled';

export const ResetEndedCalls = () => {
  const [isPopperVisible, contactCalls, isLoading] = useUnit([
    $isPopperVisible,
    $contactCalls,
    $isLoading,
  ]);
  const { t } = useTranslation();

  const allCallsList = isPopperVisible === 'all';
  const hasEndedCalls = contactCalls.some(({ call }) => !!call.ended_at);

  if (!allCallsList || !hasEndedCalls || isLoading) return null;

  return (
    <>
      <Divider />

      <Styled.ResetEndedCalls>
        <Styled.ResetButton
          fullWidth
          variant="text"
          size="medium"
          onClick={() => clearEndedCalls()}
        >
          {t('ClearCompleted')}
        </Styled.ResetButton>
      </Styled.ResetEndedCalls>
    </>
  );
};
